import { useSearchParams } from "react-router-dom";
import PageHeader from "@/components/layout/PageHeader";
import OrderForm from "@/components/OrderForm";
import { SERVICE_TYPES, WB_DISTRICTS } from "@/lib/constants";
import { ShieldCheck, Truck, Timer } from "lucide-react";

export default function OrderPage() {
  const [sp] = useSearchParams();
  const svc = sp.get("service");
  const defaultService = SERVICE_TYPES.includes(svc) ? svc : "";

  return (
    <>
      <PageHeader
        eyebrow="Order FASTag"
        title="FASTag delivered across all 23 West Bengal districts."
        subtitle="Fill in the form below — our team will call you to confirm KYC and delivery address."
      />
      <section className="py-16 sm:py-20 bg-[#F8FAFC]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5 space-y-6">
            <div className="bg-white rounded-2xl border border-[#E2E8F0] p-6 shadow-sm">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-[#0057B8]/10 text-[#0057B8] grid place-items-center"><Truck className="w-5 h-5" /></div>
                <div className="font-display font-semibold">All 23 districts covered</div>
              </div>
              <p className="mt-2 text-sm text-[#6B7280]">Delivery coordinated to: {WB_DISTRICTS.join(", ")}.</p>
            </div>
            <div className="bg-white rounded-2xl border border-[#E2E8F0] p-6 shadow-sm">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-[#0E7490]/10 text-[#0E7490] grid place-items-center"><ShieldCheck className="w-5 h-5" /></div>
                <div className="font-display font-semibold">KYC guidance included</div>
              </div>
              <p className="mt-2 text-sm text-[#6B7280]">We walk you through RC, KYC docs and vehicle photo requirements.</p>
            </div>
            <div className="bg-white rounded-2xl border border-[#E2E8F0] p-6 shadow-sm">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-[#F59E0B]/15 text-[#B45309] grid place-items-center"><Timer className="w-5 h-5" /></div>
                <div className="font-display font-semibold">Same-day counter service</div>
              </div>
              <p className="mt-2 text-sm text-[#6B7280]">Walk-in customers at Bally Toll usually receive their tag the same day.</p>
            </div>
          </div>
          <div className="lg:col-span-7">
            <OrderForm defaultService={defaultService} />
          </div>
        </div>
      </section>
    </>
  );
}
